import GroupsIcon from "@mui/icons-material/Groups";
import {
    Avatar,
    Box,
    Typography
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import DefaultUniversity from "../../../../Assets/img/default-university-logo.jpg";
import { ReactComponent as InviteIcon } from "../../../../Assets/img/icons/invite-figma.svg";
import { ReactComponent as ShareIcon } from "../../../../Assets/img/icons/share-icon-figma.svg";
import { useQuantityContext } from "../../../QuantityContext";
import { InviteProfile, ShareProfile, ViewConnections } from "../../MyProfileDetails/ProfileConnectionComponents";
import { useProfileContext } from "../../../ProfileDetailContext";
import CryptoJS from "crypto-js";
import { useUserDetailContext } from "Components/UserDetailContext";

const UserCompo = () => {
  const ProfessionalData = useSelector(
    (state) => state?.ProfileArray?.professionaProfile
  );
  const ProfessionalExperience =
    useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
  const { userDetails } = useUserDetailContext();
  const { openSnackbar } = useQuantityContext();
  const encryptedUrlRef = useRef("");
  const { connectionList, setConnectionList } = useProfileContext();
  const sortedExperienceList = [...(ProfessionalExperience || [])];
  const [openInviteProfile, setOpenInviteProfile] = useState(false);
  const [connectionViewModal, setConnectionViewModal] = useState(false);
  const [mostRecentExperience, setMostRecentExperience] = useState({
    companylogo: {
      name: "",
      type: "",
      data:
        sortedExperienceList && sortedExperienceList.length > 0
          ? sortedExperienceList[0]?.company_logo
          : "",
    },
    companyName:
      sortedExperienceList && sortedExperienceList.length > 0
        ? sortedExperienceList[0]?.company_name
        : "",
  });

  const handleSuccess = (message = "", op = "Save") => {
    let successMessage;
    if (op === "Delete")
      successMessage =
        message && message !== "" ? message : "Deleted Successfully!";
    else if (op === "Save")
      successMessage =
        message && message !== "" ? message : "Saved Successfully!";
    openSnackbar(successMessage, "success", 3000);
  };

  const handleFailure = (message = "", op = "Save") => {
    let failureMessage;
    if (op === "Delete")
      failureMessage =
        message && message !== "" ? message : "Failed to Delete. Try Again.";
    else if (op === "Save")
      failureMessage =
        message && message !== "" ? message : "Failed to Save. Try Again.";
    openSnackbar(failureMessage, "error", 3000);
  };
  const [shareProfileConfig, setShareProfileConfig] = useState({
    open: false,
    onClose: undefined,
    qrCodeUrl: "",
    qrCodeLogo: undefined,
    showQr: true,
    isDownload: false,
    profileType: "",
    handleSuccess: handleSuccess,
    handleFailure: handleFailure,
  });
  const mostRecentExpLogo =
    mostRecentExperience?.companylogo?.data || DefaultUniversity;
  const Personaldata = useSelector(
    (state) => state?.ProfileArray?.personalProfile?.data
  );

  // Extract name from email if needed
  const userName =
    userDetails?.firstName + " " + userDetails?.lastName || "User";

  const updateShareProfileConfig = (newConfig) => {
    setShareProfileConfig((prevConfig) => ({
      ...prevConfig,
      ...newConfig,
    }));
  };
  
   useEffect(() => {
      if (Personaldata?.user_ref_id) {
        const encryptedId = CryptoJS.AES.encrypt(
          Personaldata?.user_ref_id?.toString(),
          "UserDetailsSecretKey"
        ).toString();
        encryptedUrlRef.current = encodeURIComponent(encryptedId);
        // console.log("encrypted id ", encryptedUrlRef.current);
      }
    }, [Personaldata]);

  const handleShareProfile = () => {
    console.log(
      "encryptedUrlRef.currentencryptedUrlRef.current",
      encryptedUrlRef.current
    );
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${encryptedUrlRef.current}`,
      qrCodeLogo: mostRecentExpLogo,
      showQr: true,
      profileType: "Professional Profile",
    });
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f4f4f4",
        maxHeight: "750px",
        overflowY: "auto",
        scrollbarWidth: "none",
        borderRadius: 2,
        boxShadow: 2,
      }}
    >
      {/* Cover Section */}
      <Box
        sx={{
          position: "relative",
          height: 100,
          backgroundImage: `url('${
            ProfessionalData?.user_cover_url ||
            `${process.env.REACT_APP_CARD_URL}/static/media/Personal_bg_image.8d28ab37d967d482b89b.png`
          }')`,
          backgroundSize: "cover", // Changed from 100% 100% to prevent stretching
          backgroundPosition: "center",
          backgroundColor: ProfessionalData?.user_cover_url
            ? "transparent"
            : "#e0e0e0", // Fallback color
        }}
      >
        {/* Profile Picture */}
        <Avatar
          src={ProfessionalData?.user_profile_url}
          alt={userName}
          sx={{
            width: 70,
            height: 70,
            position: "absolute",
            bottom: -30, // Reduced from -60 to minimize gap
            left: 20,
            border: "4px solid white",
            backgroundColor: "white", // Ensure visibility if image missing
          }}
        />
      </Box>

      {/* Profile Content */}
      <Box p={3} sx={{ backgroundColor: "white" }}>
        {/* Name and Title */}
        <Typography variant="h5" fontWeight="bold">
          {userName}
        </Typography>
        <Typography variant="body1" color="textSecondary" mb={1}>
          {ProfessionalData?.designation} | {ProfessionalData?.department}
        </Typography>

        {/* Contact Information */}
        <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
          <Typography variant="body2">
            <Box
              display="flex"
              alignItems="center"
              gap={0.5}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setConnectionViewModal(true);
              }}
            >
              <GroupsIcon className="color-blue" />{" "}
              <span className="color-blue">
                {Personaldata?.connection_count || 0} Connections
              </span>
            </Box>
          </Typography>
          <Typography variant="body2">
            <Box display="flex" alignItems="center" gap={0.5}>
              <Box
                className="profile-meta-info pointer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={handleShareProfile}
              >
                <ShareIcon sx={{ mr: 0.5 }} />
                <span>Share</span>
              </Box>
            </Box>
          </Typography>
          <Typography variant="body2">
            <Box display="flex" alignItems="center" gap={0.5}>
              <Box
                className="profile-meta-info pointer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpenInviteProfile(true);
                }}
              >
                <InviteIcon sx={{ mr: 0.5 }} />
                <span>Invite</span>
              </Box>
            </Box>
          </Typography>
        </Box>

        <ShareProfile
          open={shareProfileConfig.open}
          onClose={shareProfileConfig.onClose}
          qrCodeUrl={shareProfileConfig.qrCodeUrl}
          qrCodeLogo={shareProfileConfig.qrCodeLogo}
          showQr={shareProfileConfig.showQr}
          isDownload={shareProfileConfig.isDownload}
          profileType={shareProfileConfig.profileType}
          userName={shareProfileConfig.userName}
          handleSuccess={shareProfileConfig.handleSuccess}
          handleFailure={shareProfileConfig.handleFailure}
        />

        <ViewConnections
          open={connectionViewModal}
          onClose={() => setConnectionViewModal(false)}
          connectionCount={Personaldata?.connection_count || 0}
          connectionList={connectionList || []}
          setConnectionList={setConnectionList}
        />

        <InviteProfile
          open={openInviteProfile}
          setModalOpen={setOpenInviteProfile}
          handleSuccess={handleSuccess}
          handleFailure={handleFailure}
        />
      </Box>
    </Box>
  );
};

export default UserCompo;
